import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeRecordCreditTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.record.credit-trend",
  name: "Posted credit trend",
  description: "Posted credit trend across the selected period.",
  apps: [
    "finance",
    "configuration",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "finance.posted-journal-items",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "credit",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Credits",
        query: {
          version: 1,
          source: "finance.posted-journal-items",
          ...period(30),
          select: [
            {
              type: "field",
              field: "accounting_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "credit",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "accounting_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#2fb344",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Posted credit trend",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "0",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
